import { useState } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';

import { FaPlus } from 'react-icons/fa';

export default function Team() {
  let team_members = [
    {
      'id' : 1,
      'name' : "Justin Estrada",
      'role' : "Owner",
    }
  ];

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <>
      <div className="title-container text-center">
        <h2>Team</h2>
        <p>These people are part of your group. They are added to all of your events by default.</p>
        <Button variant="secondary" onClick={handleShowModal}>
          Add Team Member <FaPlus />
        </Button>
      </div>
      <section className="team-members">
        <Row>
          {team_members.map(team_member => (
            <Col key={team_member.id}>
              <Card>
                <h3>{team_member.name}</h3>
                <br/>
                <i>{team_member.role}</i>
              </Card>
            </Col>
          ))}
        </Row>
      </section>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
